export default "__VITE_ASSET__1b262229__"